export default () => ({
  // The Page Status Code (200,404,500 for example)
  statusCode: undefined,

  // The Debug flag
  debug: undefined,

  // The use Cache Flag
  useCache: undefined,

  // The Page Breadcrumbs
  breadcrumbs: [],

  // IS MOBILE flag used on a change orientation
  isMobile: false,

  // banners data info
  banners: [],

  // Page expiresAt timestamp
  expiresAt: undefined,

  // FAQs
  faqs: [],

  // Page Query Params
  pageQueryParams: {},

  // Preview Mode (rendering a stored admin preview instead of the live page)
  isPreview: false,
  // The requested preview version (e.g. 214)
  previewVersion: undefined,
  // The entity type being previewed (magazine today, category/cms later)
  previewTag: undefined,
  // The unguessable Mongo entity_id of the preview
  previewEntityId: undefined,
  // The human-friendly product id/code of the preview (e.g. OKMG)
  previewId: undefined,
  // When the preview snapshot was generated (top-level created_at from the API)
  previewCreatedAt: undefined,
  // Who generated the preview snapshot (top-level generated_by from the API)
  previewGeneratedBy: undefined,
  // A user-facing message when a preview is missing/expired/not found
  previewError: undefined,
  // Sitewide preview (rendering an unpublished sitewide promotion passed on the URL)
  isSitewidePreview: false,
  // The decoded per-slot preview payloads (for the preview banner display)
  sitewidePreviewDesktop: undefined,
  sitewidePreviewMobile: undefined
})
